import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { Step, StepButton } from '@material-ui/core';
import { map } from 'lodash';

import Stepper, { StepperProps } from './Stepper';

const messages = defineMessages({
  markDuplicates: {
    id: 'components.v2.StepperPatientMerge.markDuplicates',
    defaultMessage: 'Mark Duplicates',
  },
  review: {
    id: 'components.v2.StepperPatientMerge.review',
    defaultMessage: 'Review',
  },
  done: {
    id: 'components.v2.StepperPatientMerge.done',
    defaultMessage: 'Done',
  },
});

export enum StepperPatientMergeStep {
  MarkDuplicates = 'markDuplicates',
  Review = 'review',
  Done = 'done',
}

export interface StepperPatientMergeProps extends Omit<StepperProps, 'classes' | 'children'> {
  onStepClick: (step: StepperPatientMergeStep) => void;
}

const StepperPatientMerge: React.FC<StepperPatientMergeProps> = ({ onStepClick, ...rest }) => {
  const { formatMessage } = useIntl();

  return (
    <Stepper alternativeLabel {...rest}>
      {map(StepperPatientMergeStep, (step) => (
        <Step key={step} disabled={rest.activeStep === 2 || step !== StepperPatientMergeStep.MarkDuplicates}>
          <StepButton onClick={() => onStepClick(step)}>{formatMessage(messages[step])}</StepButton>
        </Step>
      ))}
    </Stepper>
  );
};

export default StepperPatientMerge;
